import { COUNTRIES } from '@/modules/Employee/constants'
import { FilterSelect } from '@/components/ui/filters'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface CountrySelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    disabled?: boolean
    label?: string
    onChangeAfterHookForm?: () => void
}

const CountrySelect = <T extends FieldValues>({
    control,
    name,
    multiple,
    label,
    disabled = false,
    onChangeAfterHookForm,
}: CountrySelectProps<T>) => {
    const { t } = useTranslation()
    return (
        <FilterSelect
            control={control}
            name={name}
            label={t(label || 'country')}
            placeholder={t(label || 'country')}
            options={COUNTRIES}
            showClearButton={false}
            disabled={disabled}
            multiple={multiple}
            onChangeAfterHookForm={onChangeAfterHookForm}
        />
    )
}

export default CountrySelect
